// JWT認証ユーティリティ
export const AUTH_CONFIG = {
  // JWT有効期限（ミリ秒）- 10日間
  TOKEN_EXPIRY_TIME: 10 * 24 * 60 * 60 * 1000
};

// トークンの有効性をチェック
export const isTokenValid = () => {
  const token = localStorage.getItem('token');
  const loginTime = localStorage.getItem('loginTime');
  
  if (!token || !loginTime) {
    return false;
  }

  try {
    // 時間ベースでのチェック（シンプルに）
    const tokenAge = Date.now() - parseInt(loginTime);
    return tokenAge < AUTH_CONFIG.TOKEN_EXPIRY_TIME;
    
  } catch (error) {
    console.error('Token validation error:', error);
    return false;
  }
};

// トークンの残り時間を取得（ミリ秒）
export const getTokenRemainingTime = () => {
  const token = localStorage.getItem('token');
  const loginTime = localStorage.getItem('loginTime');
  
  if (!token || !loginTime) return 0;

  try {
    // Bearer プレフィックスを除去
    const actualToken = token.replace('Bearer ', '');
    
    // JWT形式かチェック
    if (actualToken.split('.').length === 3) {
      try {
        const payload = JSON.parse(atob(actualToken.split('.')[1]));
        
        if (payload.exp) {
          const remainingTime = (payload.exp * 1000) - Date.now();
          return Math.max(0, remainingTime);
        }
      } catch (jwtError) {
        console.log('JWT decode failed, using time-based calculation');
      }
    }
    
    // 時間ベースで計算
    const tokenAge = Date.now() - parseInt(loginTime);
    const remainingTime = AUTH_CONFIG.TOKEN_EXPIRY_TIME - tokenAge;
    return Math.max(0, remainingTime);
    
  } catch (error) {
    console.error('Token time calculation error:', error);
    return 0;
  }
};

// ログアウト処理
export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('userInfo');
  localStorage.removeItem('loginTime');
  window.location.href = '/login';
};

// 自動ログアウトタイマーを設定
export const setupAutoLogout = () => {
  const remainingTime = getTokenRemainingTime();
  
  if (remainingTime <= 0) {
    logout();
    return;
  }

  // 自動ログアウトタイマーのみ設定（警告なし）
  setTimeout(() => {
    logout();
  }, remainingTime);
};